import { Link } from 'react-router-dom';
import { CategorySubCategory } from 'api/categories/_requests';
import { Col, Row, Card } from 'react-bootstrap';

const CategorySubCategoryList = ({
  categorySubCategory
}: {
  categorySubCategory: CategorySubCategory[];
}) => {
  return (
    <div className="text-start">
      {categorySubCategory.map((categoryType, idx) => (
        <div key={idx} className="mb-5">
          <h4 className="mb-4 text-danger">{categoryType.name}</h4>
          <Row className="gx-4 gy-4">
            {categoryType.categories?.map((category, catIndex) => (
              <Col xs={12} sm={6} md={4} lg={2} key={catIndex}>
                <Card className="h-100 border-0">
                  <Card.Body className="p-0">
                    <h5 className="text-secondary m-0 p-0">{category.name}</h5>
                    <ul className="list-unstyled mt-3 mb-0">
                      {category.subcategories?.map((subcategory, subIdx) => (
                        <li
                          key={subIdx}
                          className="fw-normal mb-1 text-dark hover-primary"
                          style={{ cursor: 'pointer', fontSize: '0.85rem' }}
                        >
                          {subcategory.name}
                        </li>
                      ))}
                    </ul>
                    <Link
                      to="/apps/e-commerce/customer/category"
                      className="stretched-link"
                    />
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      ))}
    </div>
  );
};

export default CategorySubCategoryList;
